<template lang="pug">
FetchErrorTransition(
  :isFetching="isFetching"
  :error="fetchError"
  )
  BillingSettings(
    :userIsAdvanced="userIsAdvanced"
    @save="save"
  )
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import BillingSettings from '@v/settings/application/billing/BillingSettings.vue'
import Permission from '@v/models/UserPermissionEnum.js'
import { parseAxiosException } from '@/helpers/exceptionParser.js'

export default {
  name: 'BillingSettingsWrapper',
  components: { BillingSettings },
  props: {
    businessUnitKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('businessUnitBillingData', ['fetchError', 'saveError', 'billing']),
    ...mapGetters('businessUnitBillingData', ['isFetching']),
    ...mapGetters('briqState', ['enabledFeatures', 'userHasPermission', 'isFetchingBriqState']),
    userIsAdvanced() {
      return this.userHasPermission(Permission.API_Admin_Settings_Read)
    },
  },
  methods: {
    ...mapActions('businessUnitBillingData', ['fetchBusinessUnitBillingData', 'saveCustomerInChargebee']),
    async save() {
      const success = await this.saveCustomerInChargebee(this.billing)
      if (success) 
        this.$notifySuccess('Successfully saved customer')
      else {
        let parsedEcxeption = parseAxiosException(this.saveError)
        this.$handleError({
          error: this.saveError,
          notification: parsedEcxeption.data.FriendlyDescription || 'Could not save customer, something went wrong',
        })
        if(parsedEcxeption.data.TechnicalDescription)
          console.error(parsedEcxeption.data.TechnicalDescription)
      }
    }
  },
  async beforeMount() {
    await this.fetchBusinessUnitBillingData(this.businessUnitKey)
  },
}
</script>
